import { createContext, useContext, useState } from 'react';
import { Drawer } from '../models';

const DrawerContext = createContext<Drawer>({
    drawerOpen: false,
    setDrawerOpen: () => {},
});

interface Props {
    children: React.ReactNode;
}

export function DrawerProvider({ children }: Props) {
    const [drawerOpen, setDrawerOpen] = useState<boolean>(true);

    return (
        <DrawerContext.Provider
            value={{
                drawerOpen,
                setDrawerOpen,
            }}
        >
            {children}
        </DrawerContext.Provider>
    );
}

export const useDrawerContext = () => useContext(DrawerContext);
